<template>
  <div class="retention-wrapper">
    <div class="section-title">
      <i class="el-icon-download"></i>
      <span class="title-name">留货下单</span>
    </div>
    <div class="retention-table-wrapper">
      <el-form
        :model="retentionForm"
        :rules="rules"
        ref="retentionForm"
        class="retention-form"
      >
        <div class="client-wrapper">
          <div class="label"><span class="required">*</span> 客户名称：</div>
          <div class="content">
            <el-form-item prop="clientId">
              <el-select
                v-model="retentionForm.clientId"
                filterable
                clearable
                placeholder="请选择客户"
                style="width: 100%"
              >
                <el-option
                  v-for="item in clientNames"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="remarks-wrapper">
          <div class="remark-label">留货备注：</div>
          <div class="remark-content">
            <el-form-item prop style="width: 100%">
              <el-input
                type="textarea"
                class="remark"
                :rows="4"
                placeholder="请输入内容"
                v-model="retentionForm.remark"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <el-table
          v-loading="tableLoading"
          :data="retentionForm.items"
          border
          class="retention-table"
          style="width: 100%"
        >
          <el-table-column prop="id" label="*产品简码" align="center">
            <template slot-scope="scope">
              <el-form-item
                style="width: 100%"
                :prop="'items.' + scope.$index + '.productId'"
                :rules="[
                  {
                    required: true,
                    message: '请选择简码',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-select
                  v-model="scope.row.productId"
                  filterable
                  clearable
                  placeholder="请选择"
                  @change="
                    codeChange(scope.row.productId, scope.$index, scope.row)
                  "
                >
                  <el-option
                    v-for="item in prodcutOptions"
                    :key="item.id"
                    :label="item.simpleCode"
                    :value="item.id"
                  >
                    <span
                      >{{ item.simpleCode || item.id }} - {{ item.series }} -
                      {{ item.specification }} - {{ item.quantity }}</span
                    >
                    <!-- <el-popover
                          placement="top-start"
                          trigger="hover">
                          <div></div>
                          <div>{{item.specification}}</div>
                          <div>{{item.quantity}}</div>
                          <span slot="reference">{{item.simpleCode}}({{item.id}})</span>
                    </el-popover>-->
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="series" label="产品系列" align="center">
            <!-- <template slot-scope="scope">
                  <el-input type="textarea" :rows="2" v-model="scope.row.series" class="row-input"></el-input>
            </template>-->
          </el-table-column>
          <el-table-column prop="specification" align="center" label="规格">
            <!-- <template slot-scope="scope">
                  <el-input type="textarea" :rows="2" v-model="scope.row.specification" class="row-input"></el-input>
            </template>-->
          </el-table-column>
          <el-table-column prop="unitsPerPack" align="center" label="片/箱">
            <!-- <template slot-scope="scope">
                  <el-input type="textarea" :rows="2" v-model="scope.row.unitsPerPack" class="row-input"></el-input>
            </template>-->
          </el-table-column>
          <el-table-column
            prop="quantity"
            align="center"
            label="*数量"
            width="180"
          >
            <template slot-scope="scope">
              <el-form-item
                style="width: 100%"
                :prop="'items.' + scope.$index + '.quantity'"
                :rules="[
                  {
                    required: true,
                    message: '请输入数量',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input-number
                  v-model="scope.row.quantity"
                  :min="0"
                  size="small"
                ></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="unit" align="center" label="单位">
            <!-- <template slot-scope="scope">
                  <el-input type="textarea" :rows="2" v-model="scope.row.unit" class="row-input"></el-input>
            </template>-->
          </el-table-column>
          <el-table-column
            v-if="false"
            prop="area"
            align="center"
            label="可销售数量"
          >
            <!-- <template slot-scope="scope">
                  <el-input type="textarea" :rows="2" v-model="scope.row.area" class="row-input"></el-input>
            </template>-->
          </el-table-column>
          <el-table-column prop="control" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="delete-btn"
                size="small"
                @click="handleretentionDelete(scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="btn-group">
          <el-button class="add" @click="handleretentionAdd">+增加</el-button>
          <el-button
            type="danger"
            class="submit"
            @click="handelSubmit"
            v-if="type === 'add'"
            >提交</el-button
          >
          <el-button
            type="warning"
            class="submit"
            @click="handelEdit"
            v-if="type === 'edit'"
            >修改</el-button
          >
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "retentionAdd",
  data() {
    return {
      type: "add",
      tableLoading: false,
      clientNames: [],
      prodcutOptions: [],
      retentionForm: {
        clientId: "",
        items: [],
        remark: "",
      },
      itemsCopyForEdit: [],
      rules: {
        clientId: [
          {
            required: true,
            message: "请选择客户",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    isRightToolBar() {
      return this.$store.state.app.rightToolBar;
    },
    isMobile() {
      return this.$store.state.app.isMobileMode;
    },
  },
  created() {
    this.type = this.$route.query.type;
    this.getClientNames();
    this.getProductOptions();
  },
  methods: {
    ...mapMutations({
      ToggleMobileSideBar: "app/ToggleMobileSideBar",
      ToggleToolBar: "app/ToggleToolBar",
      CloseMobileSideBar: "app/CloseMobileSideBar",
      CloseToolBar: "app/CloseToolBar",
    }),
    getProjectForm(id) {
      this.tableLoading = true;
      this.$api
        .get(`/reserves/${id}/form`)
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            this.retentionForm.clientId = res.data.clientId;
            this.retentionForm.remark = res.data.remark;
            res.data.products.forEach((ele) => {
              let target = this.prodcutOptions.find(
                (element) => element.id === ele.productId
              );
              let items = {
                id: ele.id,
                productId: ele.productId,
                quantity: ele.quantity,
                series: target.series,
                simpleCode: target.simpleCode,
                specification: target.specification,
                unit: target.unit,
                unitsPerPack: target.unitsPerPack,
              };
              this.retentionForm.items.push(items);
              this.itemsCopyForEdit.push(items);
            });
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          console.error(err.response);
          this.$message.error(err.response.data.message);
        });
      // 因为拦截器对401和404全局拦截后，不会再分发事件到具体请求的catch中，所以loading放在尾部关闭即可
      this.tableLoading = false;
    },
    getClientNames() {
      this.$api
        .get(`/clients/selections`)
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            this.clientNames = res.data;
          }
        })
        .catch((err) => {
          console.error(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    getProductOptions() {
      this.$api
        .get(`/reserves/products/selections`)
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            this.prodcutOptions = res.data;
            if (this.$route.query.id) {
              this.getProjectForm(this.$route.query.id);
            }
          }
        })
        .catch((err) => {
          console.error(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    codeChange(value, index, item) {
      let target = this.prodcutOptions.filter((ele) => ele.id === value);
      if (target.length <= 0) {
        this.retentionForm.items.splice(index, 1);
        return;
      }
      // console.log('index',index)
      // console.log('item',item)
      item.id = null;
      item.quantity = target[0].quantity;
      item.series = target[0].series;
      item.simpleCode = target[0].simpleCode;
      item.specification = target[0].specification;
      item.unit = target[0].unit;
      item.unitsPerPack = target[0].unitsPerPack;
    },
    handleretentionAdd() {
      this.retentionForm.items.push({
        id: null,
        productId: "",
        quantity: null,
        series: "",
        simpleCode: "",
        specification: "",
        unit: "",
        unitsPerPack: null,
      });
    },
    handleretentionDelete(index) {
      this.retentionForm.items.splice(index, 1);
    },
    // 对数据进行整合汇总，整理成符合传回去的数据格式
    organizeParams() {
      let paramItems = [];
      this.retentionForm.items.forEach((ele) => {
        if (this.type === "edit") {
          // 编辑修改模式下需要回传id
          // 修改后的是否与修改前的有相同产品，如果有，把修改前的id赋值给修改后的同产品的id
          let target = this.itemsCopyForEdit.find(
            (tar) => tar.productId === ele.productId
          );
          paramItems.push({
            id: target ? target.id : ele.id,
            productId: ele.productId,
            quantity: ele.quantity,
          });
        } else {
          paramItems.push({
            productId: ele.productId,
            quantity: ele.quantity,
          });
        }
      });
      return {
        clientId: this.retentionForm.clientId,
        products: paramItems,
        remark: this.retentionForm.remark,
      };
    },
    handelSubmit() {
      this.$refs["retentionForm"].validate((valid) => {
        if (valid) {
          // 因为element验证只会针对有数据的时候的验证，所以这里还要做一次没写产品数据的验证
          let target = this.organizeParams();
          if (target.products && target.products.length <= 0) {
            this.$message.warning("产品不能为空！");
            return false;
          }
          this.tableLoading = true;
          this.$api
            .post("/reserves", this.organizeParams())
            .then((res) => {
              if (res.status === 201 || res.status === 200) {
                this.tableLoading = false;
                this.$confirm("添加成功，是否返回列表?", "提示", {
                  confirmButtonText: "返回列表",
                  cancelButtonText: "继续添加",
                  type: "success",
                })
                  .then(() => {
                    this.$router.push({
                      path: "/retention/list",
                      query: {
                        refresh: true,
                      },
                    });
                  })
                  .catch(() => {
                    this.initForm();
                    this.$refs["retentionForm"].resetFields();
                  });
              }
            })
            .catch((err) => {
              this.tableLoading = false;
              console.error(err.response);
              if (err.response.data.status === 403) {
                this.$message.error("访问受限403");
              } else {
                this.$message.error(err.response.data.message);
              }
            });
        } else {
          this.$message.warning("表单有误!");
          return false;
        }
      });
    },
    handelEdit() {
      this.tableLoading = true;
      this.$refs["retentionForm"].validate((valid) => {
        if (valid) {
          let target = this.organizeParams();
          if (target.products && target.products.length <= 0) {
            this.$message.warning("产品不能为空！");
            return false;
          }
          this.$api
            .put(`/reserves/${this.$route.query.id}`, this.organizeParams())
            .then((res) => {
              if (res.status === 201 || res.status === 204) {
                this.tableLoading = false;
                this.$message.success("修改成功！");
                this.$router.push({
                  path: "/retention/list",
                  query: {
                    refresh: true,
                  },
                });
              }
            })
            .catch((err) => {
              this.tableLoading = false;
              console.error(err.response);
              this.$message.error(err.response.data.message);
            });
        } else {
          this.$message.warning("表单有误!");
          return false;
        }
      });
    },
    filterSearch() {
      // 移动端模式下需要关闭侧边栏
      if (this.isMobile) {
        this.CloseToolBar();
      }
    },
    initForm() {
      this.retentionForm = {
        clientId: "",
        items: [
          {
            id: null,
            productId: "",
            quantity: 0,
            series: "",
            simpleCode: "",
            specification: "",
            unit: "",
            unitsPerPack: 0,
          },
        ],
        remark: "",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.retention-wrapper {
  .required {
    color: #f30;
  }
  .retention-table-wrapper {
    width: 100%;
    padding-top: 30px;
    .retention-table {
      border: 1px solid #dbdbdb;
      .delete-btn {
        color: #333;
        cursor: pointer;
        &:hover {
          color: $theme_color;
        }
      }
    }
    .client-wrapper {
      width: 100%;
      min-height: 40px;
      line-height: 40px;
      margin-bottom: 18px;
      display: flex;
      justify-content: flex-start;
      overflow: hidden;
      .label {
        flex: 80px 0 0;
        font-size: 14px;
        color: #333;
        text-align: left;
      }
      .content {
        flex: 2;
        text-align: left;
      }
    }
    .remarks-wrapper {
      width: 100%;
      display: flex;
      overflow: hidden;
      .remark-label {
        flex: 80px 0 0;
        text-align: left;
        font-size: 14px;
        color: #333;
        line-height: 30px;
      }
      .remark-content {
        flex: 1;
        .remark {
          textarea {
            border: none;
          }
        }
      }
    }
    .retention-table {
      margin-top: 50px;
    }
    .btn-group {
      margin-top: 20px;
      text-align: right;
      .submit {
        background-color: $theme_color;
        border-color: $theme_color;
        color: #333;
      }
      .add {
        background-color: transparent;
        &:hover {
          color: #333;
          border: 1px solid #6e6e6e;
        }
        &:active {
          color: #333;
          border: 1px solid #6e6e6e;
        }
      }
    }
  }
  .section-title {
    width: 100%;
    padding: 19px 0 26px 0;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
    font-size: 24px;
    .title-name {
      font-size: 24px;
      color: #4a4a4a;
      font-weight: bold;
      margin-left: 8px;
    }
  }
}
// @media screen and(max-width:992px) {
//   .retention-wrapper {
//     padding: 0px 0px 20px 0px;
//     .retention-table-wrapper {
//       padding: 0;
//     }
//   }
// }
</style>
<style lang="scss">
.retention-wrapper {
  .el-input--suffix .el-input__inner {
    border: none;
    border-radius: 0;
  }
  .el-textarea {
    .el-textarea__inner {
      border: none;
      border-radius: 0px;
    }
  }
  .retention-table-wrapper {
    // 表格样式自定义
    .el-table {
      background-color: transparent;
      & ::before,
      & ::after {
        border-color: #dbdbdb;
      }
    }
    .el-table tr {
      background-color: transparent;
    }
    .el-table th {
      font-weight: normal;
      color: #000;
      background-color: #e7e7e7;
      border-color: #dbdbdb;
    }
    .el-table td {
      background-color: transparent;
      border-color: #dbdbdb;
    }
    .retention-table {
      .row-input {
        border: none;
        border-radius: 0px;
        background-color: #eeeeee;
        .el-input__inner {
          border: none;
          border-radius: 0px;
          background-color: transparent;
          &:focus {
            background: #fff;
            color: #000;
          }
        }
      }
      .el-textarea {
        .el-textarea__inner {
          border: none;
          border-radius: 0px;
          background-color: transparent;
          &:focus {
            background: #fff;
            color: #000;
          }
        }
      }
    }
  }
}
</style>



